import { render, staticRenderFns } from "./FormReplacementCost.vue?vue&type=template&id=f24c68f4"
import script from "./FormReplacementCost.vue?vue&type=script&lang=js"
export * from "./FormReplacementCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports